module.exports = __webpack_public_path__ + "img/3.ba6ce159.jpg";